import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {VisualSizesEnum} from '../../styles/commonStyles';
import {NumberInput, NumberInputProps} from '../inputs/numberInput';
import {BoxedInputChildProps, boxedInputColorReaders, inputContentStyles} from './boxedInputConstants';

/*
 * Props.
 */

export type BoxedNumberInputElementProps = NumberInputProps & BoxedInputChildProps;

/*
 * Style.
 */

interface NumberInputStyleProps {
  $size: VisualSizesEnum;
  /** Whether the increment/decrement arrows are enabled or not */
  isArrowsDisabled?: boolean;
}

const StyledNumberInput = styled(NumberInput)<NumberInputStyleProps>`
  flex: 1;
  width: 0;
  overflow: hidden;

  ${(p) => inputContentStyles[p.$size]};

  ${(p) =>
    p.isArrowsDisabled &&
    css`
      ::-webkit-outer-spin-button,
      ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      -moz-appearance: textfield;
    `}

  &::placeholder {
    color: ${boxedInputColorReaders.textPlaceholder};
  }
`;

/*
 * Component.
 */

export const BoxedNumberInputElement: FC<BoxedNumberInputElementProps> = (props) => (
  <StyledNumberInput $size={props.size} {...props} />
);
